<template>
  <b-container>
    <b-form
      class="mt-5"
      @submit.prevent="onSubmit"
    >
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group
            label="メールアドレス"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              required
              placeholder="mymail@domain.jp"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <b-button
              type="submit"
              block
              variant="primary"
            >
              <b-icon
                v-if="userProfileStatus === 'loading'"
                icon="three-dots"
                animation="cylon"
                font-scale="1"
              />
              <span v-else>
                登録を完了する
              </span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {EMAIL_VERIFICATION} from "@/store/constant";
import {mapGetters} from "vuex";

export default {
  name: 'EmailVerification',
  data() {
    return {
      form: {
        email: '',
      },
    }
  },
  computed: {
    ...mapGetters(['userProfileStatus'])
  },
  methods: {
    onSubmit() {
      this.$store.dispatch(EMAIL_VERIFICATION, this.form)
        .then(() => {
          this.$router.push('/login');
        })
    },
  }
}
</script>
